<table>
    <tr>
        <td class="matrix-enclosing">
            <div class="matrix-enclosing">
                <table *ngIf="xVariablesWithValues && yVariablesWithValues && xVariablesWithValues.length && yVariablesWithValues.length" class="matrix-table"
                    (mouseleave)="mouseOutScale()"
                    [class.table-border-colors]="!heatmapParams.showColors"
                    [class.table-border-nocolors]="heatmapParams.showColors"
                    #tableHeatmap
                >
                    <tbody>
                        <tr *ngFor="let yname of maskedYLabels; index as yindex; trackBy: trackByIndex">
                            <td (click)="sortForY(yindex)"
                                [class.table-border-colors]="!heatmapParams.showColors && !horizontalCross(-1, yindex)"
                                [class.table-border-nocolors]="heatmapParams.showColors && !horizontalCross(-1, yindex)"
                                class="ylabel-cell"
                                [qa]="{'eda-heatmap-row-label': {variable: yname }}"
                                [class.horizontal-cross-colors]="heatmapParams.showColors && horizontalCross(-1, yindex)"
                                [class.horizontal-cross-nocolors]="!heatmapParams.showColors && horizontalCross(-1, yindex)"
                            >
                                <span class="ylabel" title="{{yname}}">{{yname}}</span>
                                <b *ngIf="showAscendingArrowY(yindex)" class="caret rotate-left align-caret"></b>
                                <b *ngIf="showDescendingArrowY(yindex)" class="caret rotate-right align-caret"></b>
                            </td>
                            <td *ngFor="let xname of maskedXLabels; index as xindex; trackBy: trackByIndex"
                                title="{{yname}} on {{xname}} : {{maskedDataOrWarning(xindex,yindex)}}"
                                [style.background-color]="maskedColors[xindex][yindex]"
                                [style.color]="textColor(maskedData[xindex][yindex])"
                                [class.table-border-colors]="!heatmapParams.showColors && !horizontalCross(xindex, yindex) && !verticalCross(xindex, yindex)"
                                [class.table-border-nocolors]="heatmapParams.showColors && !horizontalCross(xindex, yindex) && !verticalCross(xindex, yindex)"
                                [class.horizontal-cross-colors]="heatmapParams.showColors &&  horizontalCross(xindex, yindex)"
                                [class.vertical-cross-colors]="heatmapParams.showColors && verticalCross(xindex, yindex)"
                                [class.horizontal-cross-nocolors]="!heatmapParams.showColors && horizontalCross(xindex, yindex)"
                                [class.vertical-cross-nocolors]="!heatmapParams.showColors && verticalCross(xindex, yindex)"
                                [class.unavailable-result]="null == maskedData[xindex][yindex]"
                                (mouseenter)="mouseOverValue(maskedData[xindex][yindex])"
                                class="matrix-value"
                                (click)="cross(xindex,yindex)"
                                >
                                {{ heatmapParams.showValues ? displayValue(maskedData[xindex][yindex]) : '' }}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td *ngFor="let xname of maskedXLabels; index as xindex; trackBy: trackByIndex" (click)="sortForX(xindex)"
                                [class.table-border-colors]="!heatmapParams.showColors && !verticalCross(xindex, -1)"
                                [class.table-border-nocolors]="heatmapParams.showColors && !verticalCross(xindex, -1)"
                                [qa]="{'eda-heatmap-column-label': {variable: xname }}"
                                [class.vertical-cross-colors]="heatmapParams.showColors && verticalCross(xindex, -1)"
                                [class.vertical-cross-nocolors]="!heatmapParams.showColors && verticalCross(xindex, -1)"
                            >
                                <div class="pull-right">
                                    <b *ngIf="showAscendingArrowX(xindex)" class="caret vertical-mirror align-caret"></b>
                                    <b *ngIf="showDescendingArrowX(xindex)" class="caret align-caret"></b>
                                </div>
                                <span [title]="xname"  class="xlabel">{{xname}}</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <p class="no-values-displayed" *ngIf="!xVariablesWithValues || !yVariablesWithValues || !xVariablesWithValues.length || !yVariablesWithValues.length">(all values are filtered)</p>
            </div>
        </td>
        <td>
            <canvas [hidden]="!heatmapParams.showColors"
                class="scale-canvas" #scaleCanvas
                (mousemove)="mouseOverScale($event)"
                (mouseout)="mouseOutScale()"></canvas>
        </td>
    </tr>
</table>
